import { render, staticRenderFns } from "./AccountRegistration.vue?vue&type=template&id=402b41ef&scoped=true&"
import script from "./AccountRegistration.vue?vue&type=script&lang=js&"
export * from "./AccountRegistration.vue?vue&type=script&lang=js&"
import style0 from "./AccountRegistration.vue?vue&type=style&index=0&id=402b41ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402b41ef",
  null
  
)

export default component.exports